# Sueño & Descanso: Siestas, Noche & Espacios Tranquilos

El descanso apoya la recuperación, el estado de ánimo y la salud inmunológica. Las mascotas duermen mucho, pero la calidad del descanso depende de la rutina, la comodidad y un entorno calmado.

<ArticleImage
  src="/images/guide/sleep-rabbit.jpg"
  alt="Reloj en una mesa de noche"
  caption="Una rutina constante ayuda a las mascotas a relajarse y dormir más rápido."
/>

---

<Section emoji="🌙" title="Patrones de Sueño Saludables">

<Tip label="Rangos típicos" text="Los perros adultos suelen dormir 12–14 horas; los gatos pueden dormir 12–16 horas. Cachorros y mayores duermen más." />
<Tip label="Siestas diurnas" text="Las siestas cortas son normales — observa la energía y el apetito en general." />
<Tip label="Cambios nocturnos" text="Si el sueño cambia de repente, anota otros síntomas como apetito o hábitos de baño." />

</Section>

<ArticleImage
  src="/images/guide/sleep-cat-cozy.jpg"
  alt="Luz tranquila de una ventana"
  caption="Un espacio calmado y cómodo favorece un descanso más profundo."
/>

<Section emoji="🏡" title="Crea una Zona de Sueño Tranquila">

<Tip label="Comodidad" text="Ofrece camas suaves y una temperatura cómoda para el tipo de pelaje." />
<Tip label="Poco ruido" text="Mantén el área de descanso lejos de TVs altas, puertas o pasillos muy transitados." />
<Tip label="Espacio seguro" text="Las jaulas o camas tipo cueva pueden hacer que algunas mascotas se sientan seguras." />

</Section>

<Section emoji="📖" title="Rutina para Dormir">

<Tip label="Mismo horario" text="Intenta mantener la última comida, el último paseo y el apagado de luces en horarios constantes." />
<Tip label="Bajar revoluciones" text="Juego suave o una sesión de cepillado tranquila puede ayudar a relajar la energía." />
<Tip label="Señales de luz" text="Atenúa las luces por la noche para indicar la hora de dormir." />

</Section>

<Section emoji="🩺" title="Cuándo Consultar">

<Tip label="Noches inquietas" text="Paseo nervioso, jadeo o despertares frecuentes pueden indicar malestar o ansiedad." />
<Tip label="Sueño excesivo" text="La letargia repentina merece revisión veterinaria, especialmente con cambios de apetito." />
<Tip label="Señales de dolor" text="Rigidez, cojera o quejidos pueden interrumpir el sueño e indicar dolor." />

</Section>

<Disclaimer title="⚠️ Recordatorio Amigable">
Esta guía es educativa y no sustituye la orientación veterinaria. Si los cambios en el sueño persisten o se acompañan de otros síntomas, contacta a tu veterinario.
</Disclaimer>
